/**
 * A responsive wrapper component that switches between grid and flex layouts based on screen size.
 * On mobile screens, it displays items in a single column.
 * On larger screens, it uses a grid layout with the specified number of columns.
 *
 * @param children - React nodes to be rendered inside the wrapper
 * @param className - Additional CSS classes to apply to the wrapper
 * @param grid_columns - Number of columns for the grid layout (defaults to 4)
 */

export function GridPartitionWrapper(
    { children, className, grid_columns }: { children: React.ReactNode; className?: string, grid_columns?: number} 
) {
    // Map grid columns to Tailwind classes
    // Cuz tailwind doesn't support just dynamic text
    const gridClass = grid_columns ? {
        1: "grid-cols-1",
        2: "grid-cols-2",
        3: "grid-cols-3",
        4: "grid-cols-4",
        5: "grid-cols-5",
        6: "grid-cols-6",
        7: "grid-cols-7",
        8: "grid-cols-8",
        9: "grid-cols-9",
        10: "grid-cols-10",
        11: "grid-cols-11",
        12: "grid-cols-12",
        13: "grid-cols-13",
        14: "grid-cols-14",
        15: "grid-cols-15",
        16: "grid-cols-16"
    }[grid_columns] ?? "grid-cols-1" : "grid-cols-4"

    return (
        <div className={`flex flex-col md:grid ${gridClass} gap-2 justify-center ${className ?? ""}`}>
            {children}
        </div>
    )
}
